import React from "react"
import useForm from "react-hook-form"
import { t } from "ttag"
import { CenteredLoader, Input } from "@humanpredictiveintelligence/myqvt-library"
import { Checkbox, FormControlLabel } from "@material-ui/core"

import { useSessionStore } from "features/Session"
import { ResendMfaCodeButton } from "../Components"
import * as Styles from "../LoginForm/LoginForm.styles"

export const MfaCodeForm: React.FC<MfaCodeFormProps> = (props) => {
  const authentication = useSessionStore(state => state.authentication)
  const [ rememberMe, setRememberMe ] = React.useState(false)

  const {
    register: registerField,
    handleSubmit,
    errors: formErrors,
    formState: { isValid },
  } = useForm<FormFields>({
    mode: "onChange",
  })

  return (
    <Styles.Form aria-label="form" onSubmit={handleSubmit(onSubmit)}>
      <Styles.Title>{t`Code validation`}</Styles.Title>
      <Styles.Fields>
        <Styles.InformationMessageBox text={t`A confirmation code has been sent to the address ${props.userEmail}`}/>
        <Input
          name="code"
          innerRef={registerField({
            required: t`This field is required`,
          })}
          label={t`Code`}
          isDisabled={props.formStatus === "processing"}
          placeholder={t`Enter the code`}
          isErroneous={!!formErrors.code}
          hint={formErrors.code && formErrors.code.message}
          isHintErroneous
        />
        <Styles.RememberMeContainer $isChecked={rememberMe}>
          <FormControlLabel
            label={t`Don't ask me for 30 days`}
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(event, isChecked) => setRememberMe(isChecked)}
                color="primary"
              />
            }
          />
        </Styles.RememberMeContainer>
      </Styles.Fields>
      <Styles.StatusContainer>
        {props.formStatus === "failed" && (
          <Styles.ErrorMessage>
            {authentication.reason}
          </Styles.ErrorMessage>
        )}

        {props.formStatus === "processing" && <CenteredLoader isTransparent />}
      </Styles.StatusContainer>
      <Styles.NavigationActions>
        <Styles.SecondaryButtonAction
          onClick={props.onBack}
        >
          {t`Back`}
        </Styles.SecondaryButtonAction>
        <Styles.PrimaryButtonAction
          submit
          disabled={props.formStatus === "processing" || !isValid}
          style={{ backgroundColor: "white" }}
        >
          {t`Connection`}
        </Styles.PrimaryButtonAction>
      </Styles.NavigationActions>

      <Styles.RetryMfaCodeContainer>
        <ResendMfaCodeButton onRetry={props.onRetryRequested}/>
      </Styles.RetryMfaCodeContainer>
    </Styles.Form>
  )

  function onSubmit(form: FormFields) {
    props.onCodeValidated(form.code, rememberMe)
  }
}

interface FormFields {
  code: string,
}

interface MfaCodeFormProps {
  userEmail: string,
  onCodeValidated: (code: string, rememberMe?: boolean) => void,
  onRetryRequested: () => void,
  onBack: () => void,
  formStatus?: string,
}
